import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from '../pages/Home';
import Menu from '../pages/Menu';
import Bucket from '../pages/Bucket';
import Login from '../pages/Login';
import Trackorder from '../pages/Trackorder';
import Feedback from '../pages/Feedback';
import Termscondition from '../pages/Termscondition';
import Privacyandpolicy from '../pages/Privacyandpolicy';
import Contactus from '../pages/ContactUs';
import MitaoBhook from '../pages/MitaoBhook';
import MitaoBhookscholarship from '../pages/MitaoBhookscholarship';

const Routing = () => {
  return (
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/menu" element={<Menu />} />
        <Route path="/bucket" element={<Bucket />} />
        <Route path="/login" element={<Login />} />
        <Route path='/track-order' element={<Trackorder/>}/>
        <Route path='/feedBack' element={<Feedback/>}/>
        <Route path='/termscondition' element={<Termscondition/>}/>
        <Route path='/privacy-policy' element={<Privacyandpolicy/>}/>
        <Route path='/Contact-us' element={<Contactus/>}/>
        <Route path='/mitao-bhook' element={<MitaoBhook/>}/>
        <Route path='/mitao-bhook-scholarship' element={<MitaoBhookscholarship/>}/>
      </Routes>
  );
}

export default Routing;
